// extracted by mini-css-extract-plugin
export default {"component":"categories_component__2y91q"};